/**
 * IS A 401 ON THIS REQUEST THE ANSWER, RATHER THAN AN EXPIRED SESSION?
 *
 * The response interceptor (axios.ts) treats a 401 as "the session token has run out": it
 * refreshes the session and sends the request again, and signs the user out if it cannot.
 * That is right for an ordinary call and wrong for a request that offers a credential, where
 * 401 means "that code was not right":
 *
 *   - sent again, a wrong code is counted against the user twice - and five wrong enrolment
 *     codes revoke the code;
 *   - mid sign-in there is no session to refresh, so the user was signed out and sent back to
 *     the start for mistyping a code.
 *
 * So: the sign-in and second-factor routes, proving a device you already have (/auth/step-up),
 * offering an enrolment code (/auth/enrolment), a mobilised user's sitting (/auth/mobilise) -
 * and ANY request sent on a token of its own rather than the session (`stepUpToken`), because
 * refreshing the session cannot change what that token is allowed to do.
 */
const CREDENTIAL_PATHS = ['/auth/login', '/auth/refresh', '/auth/totp', '/auth/step-up', '/auth/enrolment', '/auth/mobilise']

export function isCredentialAnswer(config: { url?: string; stepUpToken?: unknown } | null | undefined): boolean {
    if (!config) return false
    if (config.stepUpToken) return true
    const url = config.url || ''
    return CREDENTIAL_PATHS.some((path) => url.includes(path))
}
